<template>
  <asc-page-loading-indicator
    :loading="isAircraftDataLoading && apiPageFailure.length === 0"
  >
    <div class="asc-aircraft-data-container">
      <v-container fluid>
        <asc-page-coming-soon
          label="Aircraft Data Page Coming Soon!"
        ></asc-page-coming-soon>
      </v-container>
    </div>
  </asc-page-loading-indicator>
</template>

<script>
import { mapState } from 'vuex'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import AscPageComingSoon from '@/components/molecules/AscPageComingSoon'

export default {
  name: 'AscAircraftDataContainer',

  components: {
    AscPageLoadingIndicator,
    AscPageComingSoon,
  },

  data() {
    return {
      isAircraftDataLoading: false,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
  },
}
</script>

<style lang="scss">
.asc-fleet-list-container {
  background-color: $gray-100;

  & .container {
    padding: 16px;
  }
}
</style>
